import React from "react";
import { Link } from "react-router-dom";
import Navbarnft_global from "../Navbars/Navbarnft_global";
import Footer from "../Footer";

function Page404() {
  return (
    <>
      <Navbarnft_global />
      <div className="w3-container w3-404">
        <div className="w3-404-code w3-gradient-text">404</div>
        <h1>Page not found</h1>
        <p>The page you’re looking for doesn’t exist or has been moved.</p>
        <Link to="/" className="w3-btn w3-btn-primary">
          Back to home
        </Link>
      </div>
      <Footer />
    </>
  );
}

export default Page404;
